import QRCode from "react-qr-code";
import { QrCodeCoreProps } from "../../../types/componentsConstructors";

const QrCodeCore: React.FC<QrCodeCoreProps> = ({
  value,
  fgColor = "#000000",
  bgColor = "#FFFFFF",
  size = 200,
}) => {
  return (
    <QRCode
      value={value}
      fgColor={fgColor}
      bgColor={bgColor}
      size={size}
      style={{ borderRadius: "10px" }}
    />
  );
};

export default QrCodeCore;
